var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.component},[_c('div',{staticClass:"riddle_target",attrs:{"data-rid-id":_vm.riddleId}},[_c('iframe',{ref:"iframeRef",attrs:{"src":_vm.riddleSrc,"allow":"autoplay","referrerpolicy":"no-referrer"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }